import { animate, style, transition, trigger } from '@angular/animations';

export const fadeOut = trigger('fadeOut', [
            transition(':leave', [   // :leave is alias to '* => void'
            animate(500, style({opacity: 0})),
            ]),
        ]);
